/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import {
  CRASH_OR_ACCIDENT_TYPE,
  FAULTS_AND_HAZARDS_TYPE,
  MARINE_FARMING_DEBRIS_TYPE,
  MOORINGS_TYPE,
  NON_COMPLIANCE_ON_THE_WATER_TYPE,
  OIL_SPILL_TYPE,
  POLLUTION_TYPE,
} from '../../../../configurations/incident-report';
import {
  addIncidentDescription,
  addIncidentDetails,
  addIncidentVideo,
  reset,
  resetTags,
  setArea,
  setLocation,
  setOfflineInitiated,
  setType,
  updateIncidentVideos,
} from './actions';
import { IncidentReportState } from './models';

export const initialState: IncidentReportState = {
  selectedArea: null,
  latitude: null,
  longitude: null,
  type: null,
  incidentDateTime: null,
  description: null,
  vesselRegistration: null,
  imageUrls: [],
  videoUploads: [],
  tags: [],
  offlineInitiated: false,
  availableTypes: {
    [OIL_SPILL_TYPE.key]: OIL_SPILL_TYPE,
    [FAULTS_AND_HAZARDS_TYPE.key]: FAULTS_AND_HAZARDS_TYPE,
    [CRASH_OR_ACCIDENT_TYPE.key]: CRASH_OR_ACCIDENT_TYPE,
    [MOORINGS_TYPE.key]: MOORINGS_TYPE,
    [NON_COMPLIANCE_ON_THE_WATER_TYPE.key]: NON_COMPLIANCE_ON_THE_WATER_TYPE,
    [POLLUTION_TYPE.key]: POLLUTION_TYPE,
    [MARINE_FARMING_DEBRIS_TYPE.key]: MARINE_FARMING_DEBRIS_TYPE,
  },
};

// eslint-disable-next-line import/prefer-default-export
export const reducer = createReducer(initialState, (builder) => {
  builder.addCase(setLocation, (state, { payload }) => {
    state.latitude = payload.latitude;
    state.longitude = payload.longitude;
  });
  builder.addCase(setArea, (state, { payload }) => {
    state.selectedArea = payload.selectedArea;
  });
  builder.addCase(setType, (state, { payload }) => {
    state.type = payload.type;
  });
  builder.addCase(resetTags, (state) => {
    state.tags = initialState.tags;
  });
  builder.addCase(reset, (state) => {
    Object.assign(state, initialState);
  });
  builder.addCase(addIncidentDetails, (state, { payload }) => {
    state.tags = payload.tags;
    state.incidentDateTime = payload.incidentDateTime;
  });
  builder.addCase(updateIncidentVideos, (state, { payload }) => {
    state.videoUploads = payload || [];
  });

  builder.addCase(addIncidentVideo, (state, { payload }) => {
    if (state.videoUploads) {
      state.videoUploads.push(payload);
    } else {
      state.videoUploads = [];
    }
  });

  builder.addCase(setOfflineInitiated, (state) => {
    state.offlineInitiated = true;
  });

  builder.addCase(addIncidentDescription, (state, { payload }) => {
    if (payload.vesselRegistration)
      state.vesselRegistration = payload.vesselRegistration;

    if (payload.imageUrls) state.imageUrls = payload.imageUrls;

    state.description = payload.description;
  });
});
